import { OAuthFlowElement } from '@swagger-api/apidom-ns-openapi-3-0';

/**
 * @public
 */
class OAuthFlow extends OAuthFlowElement {}
export default OAuthFlow;